var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolygon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_90968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#8247E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2958 12.5768C20.912 12.3535 20.4131 12.3535 19.991 12.5768L16.9976 14.2884L14.9637 15.4047L11.9704 17.1163C11.5866 17.3395 11.0877 17.3395 10.6655 17.1163L8.2862 15.7768C7.90245 15.5535 7.63382 15.1442 7.63382 14.6977V12.0558C7.63382 11.6093 7.86407 11.2 8.2862 10.9768L10.6272 9.67442C11.0109 9.45117 11.5098 9.45117 11.932 9.67442L14.2729 10.9768C14.6567 11.2 14.9253 11.6093 14.9253 12.0558V13.7675L16.9593 12.6139V10.9023C16.9593 10.4558 16.729 10.0465 16.3069 9.82326L11.9704 7.36745C11.5866 7.1442 11.0877 7.1442 10.6655 7.36745L6.25226 9.82326C5.8301 10.0465 5.59985 10.4558 5.59985 10.9023V15.8512C5.59985 16.2977 5.8301 16.707 6.25226 16.9302L10.6655 19.386C11.0493 19.6093 11.5482 19.6093 11.9704 19.386L14.9637 17.7116L16.9976 16.5581L19.991 14.8837C20.3748 14.6605 20.8737 14.6605 21.2958 14.8837L23.6368 16.186C24.0205 16.4093 24.2892 16.8186 24.2892 17.2651V19.907C24.2892 20.3535 24.0589 20.7628 23.6368 20.986L21.2958 22.3256C20.912 22.5489 20.4131 22.5489 19.991 22.3256L17.65 21.0233C17.2663 20.8 16.9976 20.3907 16.9976 19.9442V18.2326L14.9637 19.386V21.0977C14.9637 21.5442 15.1939 21.9535 15.6161 22.1768L20.0294 24.6326C20.4131 24.8558 20.912 24.8558 21.3342 24.6326L25.7474 22.1768C26.1312 21.9535 26.3999 21.5442 26.3999 21.0977V16.1489C26.3999 15.7023 26.1696 15.293 25.7474 15.0698L21.2958 12.5768Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_90968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolygon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/polygon.350d09c5c42f570e322b36336ccf7a86.svg";